import { jsx as t } from "react/jsx-runtime";
import N from "classnames";
import { useState as g, useCallback as v } from "react";
import { v4 as D } from "uuid";
import w from "./index.es5640.js";
import { Z_INDEX_MODAL as b } from "./index.es174.js";
import { SplitButton as F } from "./index.es9.js";
import { Dropdown as T } from "./index.es66.js";
import { MultilineDropdownMenu as W } from "./index.es73.js";
import { SimpleTooltip as x } from "./index.es120.js";
import { IconButton as O } from "./index.es12.js";
import { Button as _ } from "./index.es11.js";
import { BasicDropdownMenu as j } from "./index.es67.js";
function y(o) {
  return "description" in o;
}
const E = ({
  menuItems: o,
  Trigger: C,
  isIconButton: a,
  testId: u,
  tooltip: f = "More Actions",
  gridApi: I,
  rowData: c
}) => {
  const [n, d] = g(!1), [m, r] = g(!1), [l, i] = g(), h = v((e) => {
    i(e), d(!0), setTimeout(() => {
      r(!0);
    }, 2);
  }, []), s = v(
    (e) => {
      r(e), !e && n && d(!1);
    },
    [n]
  ), p = v(() => {
    s(!1);
  }, [s]), M = o.map((e) => ({
    ...e,
    onClick: () => {
      var B;
      (B = e.onClick) == null || B.call(e, c, I, p), e.inlineFormMode && h(e.inlineFormMode);
    }
  })), [S, z] = g(M), k = S.some(y);
  return /* @__PURE__ */ t(
    T,
    {
      trigger: /* @__PURE__ */ t(
        x,
        {
          zIndex: b + 1,
          title: f,
          children: C
        }
      ),
      triggerMerge: !0,
      open: m,
      triggerWrapper: "inline",
      scaleToAnchor: !a,
      menuWidth: a ? 200 : void 0,
      closeOnSelection: !0,
      testId: u,
      align: "end",
      zIndex: b + 1,
      inlineMode: l,
      hasCustomItem: !1,
      isInlineModeVisible: n,
      onOpenChange: s,
      children: k ? /* @__PURE__ */ t(
        W,
        {
          items: S,
          onSelection: z
        }
      ) : /* @__PURE__ */ t(j, { items: S, onSelection: z })
    }
  );
}, U = ({
  Actions: o,
  testId: C = "action-cell",
  gridDensity: a,
  gridApi: u,
  rowData: f
}) => {
  const I = N(w.actionCellRoot, w[a]), c = a === "compact";
  return /* @__PURE__ */ t("div", { className: I, "data-testid": C, tabIndex: -1, children: o == null ? void 0 : o.map(({ menuItems: n, actionType: d, tooltip: m, onClick: r, ...l }) => {
    const i = D(), h = d === "icon-button", s = d === "split-button", p = () => {
      r == null || r(f, u);
    }, M = h ? /* @__PURE__ */ t(
      x,
      {
        zIndex: b + 1,
        title: m || "Action",
        children: /* @__PURE__ */ t(
          O,
          {
            variant: "ghost",
            ...l,
            size: c ? "small" : "default",
            isOnGrayBackground: !0,
            onClick: p
          },
          i
        )
      }
    ) : s ? /* @__PURE__ */ t(
      F,
      {
        ...l,
        ref: void 0,
        items: n,
        size: c ? "small" : "default",
        onClick: p
      },
      i
    ) : /* @__PURE__ */ t(
      _,
      {
        variant: "primary-brand",
        ...l,
        size: c ? "small" : "default",
        onClick: p
      },
      i
    );
    return n != null && n.length && !s ? /* @__PURE__ */ t(
      E,
      {
        testId: l.testId + "-dropdown",
        Trigger: M,
        menuItems: n,
        isIconButton: h,
        tooltip: m,
        gridApi: u,
        rowData: f
      },
      i
    ) : /* @__PURE__ */ t(x, { title: m, children: M }, i);
  }) });
};
export {
  U as ActionCell
};
//# sourceMappingURL=index.es628.js.map
